<template>
  <div class="pa-3">
    <v-form @submit.prevent="$v.$invalid ? () => {} : submit()" ref="form">
        <v-snackbar top right v-model="snackbar" :color="snackbar_color" :timeout="2000" >
          <span>{{message}}</span>
        </v-snackbar>
        <v-card class="neu-glow elevation-8 pb-5">
          <v-card-title primary-title>
            <div class="text-h5">Moduli</div>
            <div class="ml-8 mt-2 text-subtitle-1">Canone Mensile: {{items.filter(i => i.active).reduce((n, {price}) => n + price, 0).toFixed(2)+' €'}}</div>
            <v-spacer></v-spacer>
            <v-div>
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2" :loading="loading_update"  :disabled="items_hash==JSON.stringify(items)" @click.stop="saveItems()">
                    <v-icon color="error">mdi-content-save</v-icon>
                  </v-btn>
                </template>
                <span>Salva</span>
              </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2" @click="dialog_instruction=true">
                  <v-icon color="info">mdi-help-circle</v-icon>
                </v-btn>
              </template>
              <span>Istruzioni</span>
            </v-tooltip>                
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2" :loading="loading"  @click.stop="getData('refresh')">
                  <v-icon color="info">mdi-sync-circle</v-icon>
                </v-btn>
              </template>
              <span>Refresh</span>
            </v-tooltip>              
            </v-div>           
          </v-card-title>
          
            <v-row v-if="loading">
                <v-col class="text-center">
                  <v-progress-linear
                    color="info"
                    height="10"
                    indeterminate
                    striped
                  ></v-progress-linear>
                </v-col>
            </v-row>
            <div v-else class="mx-4">
              <v-data-table
                dense
                fixed-header
                :headers="headers"
                :items="items"
                hide-default-footer
                :items-per-page=500
                :item-class="itemClass"
                :loading="loading"
                no-data-text="Nessun dato presente in archivio"
                no-results-text="Nessun Risultato estratto"
                loading-text="Consultazione archivio: attendi..."
              >
                  <template v-slot:[`item.active`]="{ item }">
                    <v-simple-checkbox
                      v-model="item.active"
                      color="success"
                      :disabled="item.bookable==false"
                    ></v-simple-checkbox>
                  </template>

                  <template v-slot:[`item.price`]="{ item }">
                    <div>{{new Intl.NumberFormat(user.language, { style: 'currency', currency: 'EUR' }).format(item.price)}}</div>
                  </template>
              </v-data-table>

          </div>
        </v-card>
    </v-form>
    <v-dialog v-model="dialog_instruction" max-width="800">
        <v-card>
            <v-card-title class="text-h5 mb-3"
            >
              Istruzioni
            </v-card-title>
            <v-row class="mx-5">
                <v-col md="6" cols="12">
                    <p>
                        Per ogni Slot di ogni giorno e di ogni Posizione, è possibile impostre:
                        <ul>
                          <li>
                            Il numero massimo di Coperti prenotabili direttamente dal Cliente
                          </li>
                          <li>
                            Il numero massimo di Tavoli prenotabili direttamente dal Cliente
                          </li>
                          <li>
                            Il numero massimo di tavoli da 1, 2 e 3 Coperti prenotabili direttamente dal Cliente (richiede vengano inserite le capienze minime e massime di ogni tavolo)
                          </li>
                          <li>
                            La durata dello slot, ovvero per quanto tempo il cliente può impegnare il tavolo
                          </li>
                          <li>
                            La somma richiesta, per ogni coperto, per accettare la prenotazione - ad esempio capodanno - (richiede account PayPal)
                          </li>
                        </ul>
                    </p>
                </v-col>
                <v-col md="6" cols="12">
                    <p>
                      Il pulsante 'Salva' si attiva qualora rilevi differenze rispetto ai dati memorizzati.
                    </p>
                    <p>
                      Dopo il salvataggio i dati vengono automaticamente ricaricati: qualora notaste delle incongruenze, prima di fare ulteriori modifiche cliccare sul tasto 'Refresh'
                    </p>
                </v-col>
                <v-col cols="12">
                    <p color="error">
                        <strong>Attenzione:</strong> Questi vingoli valgono solo per le prenotazioni dirette da parte dei clienti. L'operatore può accettare qualsiasi prenotazione
                    </p>
                </v-col>
            </v-row>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary"  @click="dialog_instruction = false">
                OK
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>    
  </div>
</template>
<script>
import { mapGetters } from "vuex";

//import _ from 'lodash'
export default {
  data() {
    return {
      page: "Settings",
      loading:false,
      loading_update:false,
      wHeight: window.innerHeight,
      wWidth: window.innerWidth,
      dialog_editOption:false,
      dialog_instruction:false,
      items:[],
      items_hash:null,
      editedOption:null,
      loading_refresh:false,
      headers: [
                //{text: 'N', align: 'start', value: 'new'},
                //{ text: 'Opzione',        value: 'name',          align: 'start',    sortable: false, class:'px-1 text-lg-button' },
                { text: 'Descrizione',    value: 'description',   align: 'start',    sortable: false, class:'px-1 text-lg-button' },
                { text: 'Canone',         value: 'price',         align: 'end',    sortable: false, class:'px-1 text-lg-button' },
                { text: 'Attiva',         value: 'active',        align: 'center',  sortable: false, class:'px-1 text-lg-button' },
              ],     
    };
  },
  computed : {
    ...mapGetters(["settings"]),
  },
  beforeUnmount()
  {
      alert("leaving")
  },
  created(){
    this.getData()

    //console.log(716,this.user);
    /*
    if (this.user&&this.user.username=='')
    {
      this.$router.push('/auth/login').catch(() => {});
    }
    else
    {
      this.getData()
    }*/
  },
  mounted(){
    //console.log(768,this.$route.query.user)
  },
  watch : {
    item (newValue) {
      console.log(789,newValue)
      //this.getData(newValue)
    },
    assignedTable(newValue)
    {
      console.log(794,newValue)
      //this.assignedTables.push(newValue);
      console.log(796,newValue,this.assignedTables)
      this.assignTables(newValue);
    }
  },
  methods:
  {
    itemClass(item)
    {
      var clr=!item.bookable?'grey lighten-3':'';
      return clr;
    },    
    editOption(f)
    {
      this.editedOption=f;
      console.log(214,f)
      this.dialog_editOption=true;
    },
    async saveOption(a)
    {
        console.log(144,this.editedOption);
        this.loading_update=true;
        console.log(255,this.form);
        var action='';
        if(a=='delete')
        {
          action='unsetOption'
          f.active=0;
        }
        else
        {
          action='saveOption';
        }
        let payload={"action":action,"payload":JSON.stringify(this.editedOption)};
        console.log(257,payload)
        let w= await this.updateDB(payload)
        this.loading_update=false;
        console.log(260,w);
        if(w.errorid=='0')
        {
            this.snackbar_color="success"
            this.message =w.message;
            this.snackbar = true;
            this.dialog_editOption=false;
            //this.slotsByDOW_hash=JSON.stringify(this.slotsByDOW);
        }   
    },
    async saveItems()
    {
        this.loading_update=true;
        console.log(255,this.form);
        var license=this.items.filter(l=>l.active===true&&l.bookable===true).map(l=>l.value).reduce((a,b)=>a+b);
        let payload={"action":"saveItem","table":"License","payload":license};
        console.log(257,payload)
        let w= await this.updateDB(payload)
        this.loading_update=false;
        console.log(260,w);
        if(w.errorid=='0')
        {
            this.snackbar_color="success"
            this.message =w.message;
            this.snackbar = true;
             this.getData();
        }   
    },    
    async getData(origin)
    {
        {
            if(origin=='refresh')
            {
              this.loading_refresh=true;
            }
            else
            {
              this.loading=true;
            }
            try{
                const payload=JSON.stringify({"date": this.date,"action":"AllModules_get"});
                const res = await this.$http.post('/settings/settings.php', payload );
                console.log(275,res);
                this.loading_refresh=false;
                switch (res.data.errorid)
                {
                  case '0':
                      sessionStorage.setItem('jwt', res.data.jwt);
                      this.items=res.data.payloads.allModules;
                      this.items_hash=JSON.stringify(this.items);
                      console.log(315,this.items)
                  break;
                  case '0006':
                      this.$router.push('/auth/login').catch(() => {});
                  break;
                }
                this.loading= false;
            } catch(e)
            {
                this.loading= false;
                //console.log(res.data);
            }
        }
    },
    async updateDB(payload){
        try{
            const res = await this.$http.post('/settings/settings.php', payload);
            console.log(324,res);
            if (res.data.errorid=='0')
            {
            sessionStorage.setItem('jwt', res.data.jwt);
            this.snackbar_color='success';
            this.snackbar_message=res.data.message;

            if (res.data.message)
            {
                console.log(333);
                //this.snackbar=true;
            }
            }
            else
            {
              this.snackbar_color='error'
              this.snackbar_message=res.data.message;
              this.snackbar=true;
            console.log(342);
            //this.$router.push('/auth/login').catch(() => {});
            }

            //this.$store.dispatch("setUser", res.data.user); 
            return res.data;
        } catch(e)
        {
        console.log(e);
        }
    },
  },
};
</script>